// extracted by mini-css-extract-plugin
module.exports = {"page":"legal_page__o__3F","head":"legal_head__qPIXs","title":"legal_title__doumP","switch":"legal_switch__ChXBW","summary":"legal_summary__Wc0t4","body":"legal_body__vivYY"};